import React, { useEffect } from "react";
import { useCore } from "../hooks";
import './OrderDraftColumn.css'
import { OrderItemList } from "./OrderItemList.tsx";
import { Btn } from "./Btn.tsx";
import { Order } from "depoto-core";
import { toast } from "react-toastify";
import { OrderDraftEditBtns } from "./OrderDraftEditBtns.tsx";
import { OrderDraftSummary } from "./OrderDraftSummary.tsx";
import { ModalCustomer } from "./ModalCustomer.tsx";
import { useConfirmationModal } from "../utils/hooks/useConfirmationModal.tsx";
import { useNavigate } from "react-router";
import { initOrder } from "../store/core/reducer.ts";

export const OrderDraftColumn: React.FC = () => {
  const { currentOrder, setCurrentOrder, setOrderVouchers } = useCore()
  const navigate = useNavigate()
  const { ConfirmationModalComponent, showConfirmationModal, isConfirmed: isOrderDeletionConfirmed } = useConfirmationModal()
  const clearCurrentOrder = () => {
    showConfirmationModal()
  }

  useEffect(() => {
    if (isOrderDeletionConfirmed) {
      setCurrentOrder(initOrder())
      setOrderVouchers([])
      toast.warning('Objednávka smazána')
    }
  }, [isOrderDeletionConfirmed])

  const previewReservation = () => {
    navigate('/preview-reservation')
  }

  const previewBill = () => {
    navigate('/preview-bill')
  }

  return (
    <>
      <div className="w-1/2 h-body-without-header pl-2 pt-0 flex flex-col">
        <div className="bg-white  p-2 2xl:p-4 h-body-without-header flex flex-col">
          <div className="flex flex-row justify-between order-draft-header items-center">
            <div className="flex flex-row align items-center">
              <div className="font-bold text-xl">
                Doklad č. {currentOrder?.billNumber || currentOrder?.reservationNumber || '---'}
              </div>
              <div className="ml-2">
                <Btn icon={'fa-trash-can'} onClick={clearCurrentOrder} className="btn-link btn-error text-lg" />
              </div>
            </div>
            <ModalCustomer />
          </div>
          <div className="order-draft-item-list scrollable-y flex-1">
            <OrderItemList />
          </div>
          <div className="order-draft-custom-btns px-4 py-0">
            <OrderDraftEditBtns />
          </div>
          <div className="order-draft-footer pb-2">
            <OrderDraftSummary />
            <div className="flex flex-row justify-between gap-x-2">
              <Btn icon={'fa-timer'} children={'Vytvořit rezervaci'} onClick={previewReservation} isDisabled={currentOrder?.reservationNumber > 0} className="btn-success btn-outline w-1/2 order-draft-btn uppercase" />
              <Btn icon={'fa-receipt'} children={'VYSTAVIT DOKLAD'} onClick={previewBill} className="btn-success  w-1/2 order-draft-btn uppercase" />
            </div>
          </div>
        </div>
      </div>
      <ConfirmationModalComponent title={'Opravdu si přejete smazat objednávku?'}
        confirmBtnLabel={'Smazat objednávku'} />
    </>
  )
}
